import { isTimeSignature } from '@ezchops/musicsheet';
/**
 * @deprecated use TrackStems
 */
function isSampleSet(x) {
    return x != null && typeof x.tempo == 'number' &&
        (typeof x.samples == 'object');
}
/**
 * @deprecated use TrackStems
 */
export function isLoopSet(x) {
    return x != null && typeof x.id == 'string' &&
        (typeof x.ownerId == 'string') &&
        (typeof x.signature == 'object') && isTimeSignature(x.signature) &&
        (typeof x.hasMetronome == 'boolean') &&
        (Array.isArray(x.loops) && x.loops.every(isSampleSet)) &&
        (typeof x.name == 'string');
}
//# sourceMappingURL=LoopSet.js.map